import { EventTypes } from 'redux-segment';

import CONF from 'config/conf.singleton';
import { AUTH_API } from 'middleware/api';
import logger from 'utils/logger.util';

import { UPDATE_CLIENT_FAILURE, UPDATE_CLIENT_REQUEST, UPDATE_CLIENT_SUCCESS } from './saveClient.types';

const L = logger('saveClient');

const saveClient = (salonId, client) => {
  const data = { ...client };
  const clientId = data.id;

  const method = clientId ? 'PUT' : 'POST';
  const url = clientId ? `salon/${salonId}/client/${clientId}/` : `salon/${salonId}/client/`;

  L[salonId && clientId ? 'debug' : 'warn']('()', { salonId, clientId }, { client, data }, 'endpoint:', method, url);

  return {
    [AUTH_API]: {
      api_root: CONF.apiRoot,
      endpoint: url,
      authenticated: true,
      types: [UPDATE_CLIENT_REQUEST, UPDATE_CLIENT_SUCCESS, UPDATE_CLIENT_FAILURE],
      params: { salonId, clientId, data, method },
      config: {
        method,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
      },
      meta: {
        analytics: EventTypes.track,
      },
    },
  };
};

// noinspection JSUnusedGlobalSymbols
export default saveClient;
